import { ProductObj } from "../../Types";
import { DISCOUNT_TYPES } from "../../constants";

const DUMMY_IMAGE_SRC =
    "https://scalenut.blob.core.windows.net/scalenutcontainer/fbe3cae3-c3d7-4146-9ca7-bf2d2b08c080.png";

export type DummyProductType =
    | "standardWithVariant"
    | "standardNoVariant"
    | "subscriptionWithVariant"
    | "subscriptionNoVariant";

const standardProductNoVariant: ProductObj = {
    id: "dummy-volume-product",
    images: [
        {
            id: "dummy-volume-product-image",
            altText: "Sample product",
            originalSrc: DUMMY_IMAGE_SRC,
        },
    ],
    title: "Sample Product",
    handle: "sample-product",
    quantity: 1,
    maxProductStock: 100,
    selectedVariants: [],
    subscriptions: [],
    oneTimePurchase: true,
    isSubscribed: false,
    upsell_text: "{product_title}",
    variants: [
        {
            id: "dummy-volume-variant-1",
            displayName: "Sample Product - Small",
            title: "Small",
            price: "24.99",
            compareAtPrice: "34.99",
            weight: 0,
            weight_unit: "kg",
            selectedOptions: [{ name: "Size", value: "Small" }],
            image: { originalSrc: DUMMY_IMAGE_SRC },
            quantityAvailable: 100,
            availableForSale: true,
        },
    ],
    options: [],
};

const standardProductWithVariant: ProductObj = {
    ...standardProductNoVariant,
    variants: [
        {
            id: "dummy-volume-variant-1",
            displayName: "Sample Product - Small",
            title: "Small",
            price: "24.99",
            compareAtPrice: "34.99",
            weight: 0,
            weight_unit: "kg",
            selectedOptions: [{ name: "Size", value: "Small" }],
            image: { originalSrc: DUMMY_IMAGE_SRC },
            quantityAvailable: 100,
            availableForSale: true,
        },
        {
            id: "dummy-volume-variant-2",
            displayName: "Sample Product - Large",
            title: "Large",
            price: "29.99",
            compareAtPrice: "39.99",
            weight: 0,
            weight_unit: "kg",
            selectedOptions: [{ name: "Size", value: "Large" }],
            image: { originalSrc: DUMMY_IMAGE_SRC },
            quantityAvailable: 100,
            availableForSale: true,
        },
    ],
    options: [
        {
            id: "dummy-volume-option",
            name: "Size",
            position: 1,
            values: ["Small", "Large"],
        },
    ],
};

const DUMMY_SELLING_PLANS = [
    {
        id: "gid://shopify/SellingPlan/6454804574",
        name: "A year supply of prepaid ski wax, delivered monthly",
        recurringDeliveries: true,
        billingPolicy: {
            __typename: "SellingPlanRecurringBillingPolicy",
            interval: "MONTH",
            intervalCount: 12,
        },
        deliveryPolicy: {
            __typename: "SellingPlanRecurringDeliveryPolicy",
            interval: "MONTH",
            intervalCount: 1,
        },
        priceAdjustments: [{ adjustmentValue: { adjustmentPercentage: 20 } }],
    },
    {
        id: "gid://shopify/SellingPlan/6454837342",
        name: "Try our product risk-free for a week before needing to pay",
        recurringDeliveries: false,
        billingPolicy: null,
        deliveryPolicy: null,
        priceAdjustments: [],
    },
    {
        id: "gid://shopify/SellingPlan/6454870110",
        name: "Ski wax subscription, billed and delivered weekly",
        recurringDeliveries: true,
        billingPolicy: {
            __typename: "SellingPlanRecurringBillingPolicy",
            interval: "WEEK",
            intervalCount: 1,
        },
        deliveryPolicy: {
            __typename: "SellingPlanRecurringDeliveryPolicy",
            interval: "WEEK",
            intervalCount: 1,
        },
        priceAdjustments: [{ adjustmentValue: { adjustmentPercentage: 15 } }],
    },
    {
        id: "gid://shopify/SellingPlan/6454902878",
        name: "Preorder ski wax, delivered in a month",
        recurringDeliveries: false,
        billingPolicy: null,
        deliveryPolicy: null,
        priceAdjustments: [{ adjustmentValue: { adjustmentPercentage: 20 } }],
    },
];

const dummySubscriptions = DUMMY_SELLING_PLANS.map((plan) => ({
    id: plan.id,
    name: plan.name,
    checked: false,
    discountType: DISCOUNT_TYPES.PERCENTAGE,
    discountValue: plan.priceAdjustments[0]?.adjustmentValue?.adjustmentPercentage ?? 0,
    recurringDeliveries: plan.recurringDeliveries,
    ...(plan.billingPolicy && { billingPolicy: plan.billingPolicy }),
    ...(plan.deliveryPolicy && { deliveryPolicy: plan.deliveryPolicy }),
}));

const subscriptionProductWithVariant: ProductObj = {
    ...standardProductWithVariant,
    variants: [
        {
            id: "dummy-volume-subscription-variant",
            displayName: "Sample Product - Small",
            title: "Small",
            price: "24.99",
            compareAtPrice: "34.99",
            weight: 0,
            weight_unit: "kg",
            selectedOptions: [{ name: "Size", value: "Small" }],
            image: { originalSrc: DUMMY_IMAGE_SRC },
            quantityAvailable: 100,
            availableForSale: true,
            sellingPlanIds: dummySubscriptions.map((s) => s.id),
        },
    ],
    options: [],
    oneTimePurchase: true,
    isSubscribed: false,
    subscriptions: dummySubscriptions,
};

const subscriptionProductNoVariant: ProductObj = {
    ...standardProductNoVariant,
    oneTimePurchase: true,
    isSubscribed: false,
    subscriptions: dummySubscriptions,
};

export const DUMMY_PRODUCTS: Record<DummyProductType, ProductObj> = {
    standardWithVariant: standardProductWithVariant,
    standardNoVariant: standardProductNoVariant,
    subscriptionWithVariant: subscriptionProductWithVariant,
    subscriptionNoVariant: subscriptionProductNoVariant,
};
